export default __webpack_public_path__ + "static/media/redis-icon.667687f8.svg";